import styled from 'styled-components'

export const StyledBalanceContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 22px;
  margin-bottom: 7px;
  .amount {
    font-size: 12px;
    line-height: 16px;
    color: #5f4dbc;
  }
  .max {
    font-weight: 500;
    font-size: 10px;
    line-height: 10px;
    color: #5f4dbc;
    padding: 5px;
    margin-left: 5px;
    background: #d8d1fa;
    border-radius: 20px;
    cursor: pointer;
    text-align: center;
    display: inline-flex;
    align-items: center;
    height: 18px;
  }
`
